import {
  getPlatformTableListRowsMockHandler,
  getPlatformTableListRowsResponseMock,
} from 'shared/base';

import { processPaginatedListData } from '../utils';
import assetInventoryTableData from './data/assetInventoryTableData.json';

export const getCustomPlatformTableListRowsMockHandler = () => {
  return getPlatformTableListRowsMockHandler((info) => {
    if (info.params.tableName === 'cloud_assets') {
      return processPaginatedListData(info.request.url, assetInventoryTableData);
    }

    return getPlatformTableListRowsResponseMock();
  });
};
